import * as actions from '../actionTypes'
const initialState = [];

const tuitionValuesReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.SET_TUITION_VALUES:
            return action.payload;
        case actions.ADD_TUITION_VALUES:
            return [...state, action.payload];
        case actions.UPDATE_TUITION_VALUES: {
            return state.map((tuitionValue) => tuitionValue.currency === action.payload.currency ? action.payload : tuitionValue);
        }
        default:
            return state;
    }
};

export default tuitionValuesReducer;

